import React from 'react'

import NumberField from 'components/layout/form/fields/NumberField'
import TextareaField from 'components/layout/form/fields/TextareaField'
import TextField from 'components/layout/form/fields/TextField'
import { formatToUpperCase } from 'utils/form'

const OtherStake = () => (
  <>
    <TextField
      label="Etiquette : "
      name="label"
      placeholder="Ex. : AE1"
    />
    <TextField
      label="Nom : "
      name="name"
      placeholder="Ex. : une cabane au fond du jardin"
    />
    <NumberField
      label="Hauteur au sol : "
      name="fromGroundHeight"
      placeholder="Ex. : 0,95"
      unitLabel='m'
    />
    <TextField
      format={formatToUpperCase}
      label="Plancher ou T.N. de référence : "
      name="baseFlooring"
      placeholder="Ex. : N0"
    />
    <TextareaField
      label="Commentaire : "
      name="comment"
    />
  </>
)

export default OtherStake
